import { useAgTechAuthContext } from "@agtech/core/auth/AgTechAuthContext";
import { AgTechOperationUser } from './AgTechUserData';
import { AgTechQuery, useAgTechQuery } from "@agtech/core/data/queries/AgTechDataQueries";
import AgTechQueryLoadingSurface, { AgTechQueryLoadingSurfaceSettings } from "@agtech/core/data/queries/AgTechQueryLoadingSurface";
import { AgTechIdentityBaseURL } from "@agtech/core/auth/AgTechAuthData";

///
/// Queries
///

export const UserDataGetUserDetailsQuery: AgTechQuery<{ userId: string}, AgTechOperationUser> = {
    queryKey: (props) => ['User', props.userId],
    query: (props) => {
        return props.http.getEntity({
            request: {
                baseURL: AgTechIdentityBaseURL,
                path: 'Operations/Users/' + props.inputData.userId
            }
        });
    },
    content: {
        loadingText: 'Loading user...',
        failureText: 'Failed to load user.'
    }
}

///
/// Composite Queries
///

export const useUserDataGetCurrentUserQuery = () => {
    const currentUserId = useAgTechAuthContext().user.id;
    
    return useAgTechQuery({
        query: UserDataGetUserDetailsQuery,
        queryContext: { userId: currentUserId }
    });
}

///
/// Providers
///

export const UserDataProvider = (props: {
    children: (user: AgTechOperationUser) => JSX.Element,
    settings?: AgTechQueryLoadingSurfaceSettings
}) => {
    const userDataQuery = useUserDataGetCurrentUserQuery();

    return (
        <AgTechQueryLoadingSurface query={userDataQuery} {...props.settings}>
            {props.children}
        </AgTechQueryLoadingSurface>
    )
}